import moment from "moment";
import Vue from "vue";

Vue.filter("dateformat", (arg) => {
  return moment(arg).format("Do MMM YYYY");
});

Vue.filter("dayDateFormat", (arg) => {
  return moment(arg).format("dddd, MMMM Do YYYY");
});

Vue.filter("dayFormat", (arg) => {
  return moment(arg).format("DD-MMM-YYYY");
});

Vue.filter("monthFormat", (arg) => {
  return moment(arg).format("MMMM-YYYY");
});

// Vue.filter("timeStamp", (arg) => {
//   return moment(new Date(arg + " UTC")).format("Do MMM YYYY HH:mm a");
// });
Vue.filter("timeStamp", (arg) => {
  return moment
    .utc(arg)
    .local()
    .format("Do MMM YYYY hh:mm a");
});

Vue.filter("timeStampSmall", (arg) => {
  return moment(new Date(arg + " UTC")).format("DD-MM-YYYY hh:mm a");
});

Vue.filter("timeFormat", (arg) => {
  return moment(
    moment().format("YYYY-MM-DD") + " " + arg,
    "YYYY-MM-DD HH:mm:ss"
  ).format("hh:mm a");
});

Vue.filter("multiline", (string) => {
  return string.match(/.{1,100}/g).join("<br>");
});

Vue.filter("capitalize", (value) => {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("toCurrency", (value) => {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "AED",
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
});

Vue.filter("numberFormatter", (value) => {
  if (typeof value !== "number") {
    return value;
  }
  return new Intl.NumberFormat("en-IN", { maximumSignificantDigits: 3 }).format(
    value
  );
});

export default Vue.filter;
